var rich_content_viewer_default = {
  "fontElementMap": "SHlgC",
  "wrapper": "KSP0W",
  "pluginContainerMobile": "MI967",
  "viewer": "_6NFV3",
  "android": "ZcLtE",
  "rootedTraversedContent": "R0zQP",
  "atomic": "RnKax",
  "toolbar": "jUvOH",
  "block": "uDNJg"
};
export {
  rich_content_viewer_default as default
};
//# sourceMappingURL=rich-content-viewer-scss.js.map
